<template>
  <patron-profile
    ref="profile"
    @closed="(event) => $emit('closed', event)"
  />
</template>

<script>
  import PatronProfile from "../../../patron/profile/profile.vue";

  export default {
    name: "easyscreen-menu-renew-profile-screen",
    methods: {
      /**
       * Open the profile loans screen.
       */
      show() {
        this.$refs.profile.authenticate("loans");
      },
      /**
       * Close the profile loans screen.
       */
      hide() {
        this.$refs.profile.hide();
      }
    },
    components: {
      "patron-profile": PatronProfile
    }
  };
</script>
